// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"442":"4739a663","588":"628d4282","621":"628d4282","890":"f6133727"}[chunkId] + ".chunk.css";
};